export const SIGNATURES_MINT = "/signatures/mint";
export const SIGNATURES_OPEN = "/signatures/open";
export const MINT_STAGES = "/mint-stages";
export const MINT_STAGES_OPEN = "/mint-stages/open";
export const TOYS = "/toys";
export const TOYS_AVAILABILITY = "/toys/availability";
export const PETS = "/pets";
export const ALLOW_LIST = "/allow-list/";
